import { takeEvery, select } from "redux-saga/effects";
import * as actionTypes from "constants/actionTypes";
import { selectAccountId } from "reducers/account/meta";
import { selectUserId } from "reducers/user";
import { getCurrentPath } from "utils/url";

export function* trackEvent(action) {
  const { eventName, properties, options } = action.payload;

  const accountId = yield select(selectAccountId);
  const userId = yield select(selectUserId);

  const propertiesWithPath = {
    path: getCurrentPath(),
    ...properties
  };

  if (window.analytics && userId) {
    window.analytics.track(
      eventName,
      { ...propertiesWithPath, module: "webapp" },
      options
    );
  }

  if (window.amplitude && accountId) {
    // account/customer level stats are sent directly to amplitude to get around
    // the need for their enterprise package.  HOWEVER: the amplitude installation
    // in my.appcues.com hot-wires `analytics.track` to `amplitude.logEvent` so
    // there is no need to make multiple calls there.
    //
    // we'll probably switch back to a standard installation when reactcues
    // takes over, so leaving the separate call here.
    // window.amplitude.getInstance('customer').logEvent(eventName, properties);
  }
}

function* events() {
  yield takeEvery(actionTypes.TRACK_EVENT, trackEvent);
}

export default events;
